import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

const styles = () => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
    backgroundColor: '#FFFFFF',
    '-webkit-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    '-moz-box-shadow': '0px 0px 3px 0px rgba(0,0,0,0.15)',
    boxShadow: '0px 0px 3px 0px rgba(0,0,0,0.15)',
  },
});

class SearchResultHeaderPanel extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.row} style={this.props.style}>
        {this.props.children}
      </div>
    );
  }
}

SearchResultHeaderPanel.propTypes = {
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

export default withStyles(styles)(SearchResultHeaderPanel);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/panels/SearchResultHeaderPanel.jsx